/**
 * Burned-in subtitle layout for 1080×1920 reels — keep in sync with backend/lib/ass.js
 */
export const CAPTION_RENDER = {
  playResX: 1080,
  playResY: 1920,
  fontSize: 64,
  /** Preview EN size ratio (was 15px vs 18px ES before scaling). */
  fontSizeEnRatio: 15 / 18,
  marginV: 400,
  marginLR: 40,
  opacityEn: 0.5,
  outline: 2,
  shadow: 3,
};

/** Scale preview overlay CSS vars to match ASS output for the given preview box. */
export function applyCaptionPreviewScale(el) {
  if (!el) return;
  const w = el.clientWidth;
  const h = el.clientHeight;
  if (!w || !h) return;

  const sx = w / CAPTION_RENDER.playResX;
  const sy = h / CAPTION_RENDER.playResY;
  const fontEs = CAPTION_RENDER.fontSize * sy;
  const fontEn = fontEs * CAPTION_RENDER.fontSizeEnRatio;

  el.style.setProperty('--cap-sx', String(sx));
  el.style.setProperty('--cap-sy', String(sy));
  el.style.setProperty('--cap-font-es', `${fontEs}px`);
  el.style.setProperty('--cap-font-en', `${fontEn}px`);
  el.style.setProperty('--cap-bottom', `${CAPTION_RENDER.marginV * sy}px`);
  el.style.setProperty('--cap-pad-x', `${CAPTION_RENDER.marginLR * sx}px`);
  el.style.setProperty('--cap-outline', `${CAPTION_RENDER.outline * sy}px`);
  el.style.setProperty('--cap-shadow', `${CAPTION_RENDER.shadow * sy}px`);
  el.style.setProperty('--cap-en-opacity', String(CAPTION_RENDER.opacityEn));
}
